export default "__VITE_ASSET__ClvghpuU__"